import { CaseStudy } from '../../types';

export const auraJournal: CaseStudy = {
  id: '8',
  title: 'Aura Journal',
  category: 'Wellness & Mood Tracking',
  imageUrl: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1200&auto=format&fit=crop',
  description: 'Track the intangible. Aura Journal captures your mood and energy levels throughout the day, providing insights into your mental well-being through artistic visualizations.',
  screenshots: [],
  comingSoon: true
};